import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  onClick
}: CardProps) {
  return <div className={`bg-slate-900 rounded-xl border border-slate-800 shadow-sm ${onClick ? 'cursor-pointer hover:border-indigo-500/50 transition-colors' : ''} ${className}`} onClick={onClick} data-id="element-3081">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-4 border-b border-slate-800 ${className}`} data-id="element-3082">
      {children}
    </div>;
}
export function CardTitle({
  children,
  className = ''
}: CardProps) {
  return <h3 className={`text-lg font-semibold text-slate-100 ${className}`} data-id="element-3083">
      {children}
    </h3>;
}
export function CardContent({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-4 ${className}`} data-id="element-3084">{children}</div>;
}